import React from 'react';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Button } from '../../../components/ui';

const Pagination = ({ currentPage, totalPages, totalItems, itemsPerPage, onPageChange }) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  if (totalItems <= itemsPerPage) return null;

  return (
    <nav
      aria-label="Pagination"
      className="mt-6 flex flex-col gap-3 rounded-lg border border-border bg-surface px-4 py-3 shadow-sm sm:flex-row sm:items-center sm:justify-between"
    >
      <p className="text-sm text-muted-fg">
        Showing <span className="tabular font-medium text-foreground">{startItem}</span>–
        <span className="tabular font-medium text-foreground">{endItem}</span> of{' '}
        <span className="tabular font-medium text-foreground">{totalItems}</span>
      </p>

      <div className="flex items-center justify-between gap-2 sm:justify-end">
        <Button
          variant="secondary"
          size="sm"
          icon={ChevronLeft}
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </Button>

        <span className="tabular px-2 text-sm text-muted-fg">
          {currentPage} / {totalPages}
        </span>

        <Button
          variant="secondary"
          size="sm"
          iconRight={ChevronRight}
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </nav>
  );
};

export default Pagination;
